import { Combobox, Option, Textarea } from '@fluentui/react-components'
import type { PersonSummary } from '../types'

/** The optional fields every "external/shared" override mode can set (Responsible person,
 * Department, Comment) — factored out once so UserLinksTab (email->Person overrides) and
 * pages/GitHub.tsx (login->Person overrides) share the exact same inputs instead of drifting. */
export default function OverrideExtraFields(props: {
  persons: PersonSummary[]
  departments: string[]
  responsibleQuery: string
  onResponsibleQueryChange: (v: string) => void
  onResponsibleSelect: (email: string) => void
  department: string
  onDepartmentChange: (v: string) => void
  comment: string
  onCommentChange: (v: string) => void
}) {
  const {
    persons,
    departments,
    responsibleQuery,
    onResponsibleQueryChange,
    onResponsibleSelect,
    department,
    onDepartmentChange,
    comment,
    onCommentChange,
  } = props
  const filteredPersons = responsibleQuery
    ? persons.filter(
        p =>
          p.displayName.toLowerCase().includes(responsibleQuery.toLowerCase()) ||
          p.email.toLowerCase().includes(responsibleQuery.toLowerCase()),
      )
    : persons

  return (
    <>
      <Combobox
        placeholder="Responsible person (optional)"
        value={responsibleQuery}
        onChange={e => {
          onResponsibleQueryChange(e.target.value)
          onResponsibleSelect('')
        }}
        onOptionSelect={(_e, d) => {
          onResponsibleSelect(d.optionValue ?? '')
          onResponsibleQueryChange(d.optionText ?? '')
        }}
      >
        {filteredPersons.map(p => (
          <Option key={p.email} value={p.email} text={p.displayName}>
            {p.displayName} ({p.email})
          </Option>
        ))}
      </Combobox>
      <Combobox
        freeform
        placeholder="Department (optional — pick or type)"
        value={department}
        onChange={e => onDepartmentChange(e.target.value)}
        onOptionSelect={(_e, d) => onDepartmentChange(d.optionValue ?? department)}
      >
        {departments.map(d => (
          <Option key={d} value={d}>
            {d}
          </Option>
        ))}
      </Combobox>
      <Textarea placeholder="Comment (optional)" value={comment} onChange={(_e, d) => onCommentChange(d.value)} />
    </>
  )
}
